import { usePayStore } from "@/store/pay";
import { normalizePackageKey } from "@/utils/memberTier";
import type { packageTimeEnum } from "@/assets/pay";
import type { MemberUpgradePlanModalProps, ShowUpgradeModalConfig } from "./types";

/** 固定本次套餐上下文后读取试算；套餐名称一律用接口 newSubject / oldSubject，不做本地拼装。 */
export async function resolveUpgradePlanData(config: ShowUpgradeModalConfig): Promise<MemberUpgradePlanModalProps> {
  const payStore = usePayStore();
  const state = payStore.payModalState;
  const version = normalizePackageKey(config.memberType);
  const targetPackageKey = config.targetPackageKey ?? (version === "free" ? "vip" : version);
  const timeMode = config.timeMode ?? state.timeMode;
  const isBuyout = config.isBuyout ?? (config.planMode === "subscribe" ? false : state.isBuyout);
  const matchesSelection = state.memberPackage === targetPackageKey &&
    state.timeMode === timeMode && state.isBuyout === isBuyout;
  const refundInfo = Object.keys(payStore.refundInfo).length > 0 && matchesSelection
    ? payStore.refundInfo
    : await payStore.fetchUpgradeRefundForTarget(targetPackageKey, timeMode as keyof typeof packageTimeEnum, isBuyout);
  return {
    ...refundInfo,
    timeMode,
    planMode: config.planMode
  };
}
